import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed flex flex-col left-0 w-14 hover:w-64 md:w-64 bg-Third h-full text-white transition-all duration-300 border-none z-10 sidebar" }
const _hoisted_2 = { class: "overflow-y-auto overflow-x-hidden flex flex-col justify-between flex-grow" }
const _hoisted_3 = { class: "flex flex-col py-4 space-y-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex px-2 md:pl-6 md:px-0 py-8" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "103",
      height: "25",
      viewBox: "0 0 103 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M45.948 6.75512H21.4802C20.5952 6.75512 19.8769 5.81101 19.8769 4.64458C19.8769 3.47816 20.5952 2.53405 21.4802 2.53405H45.948C46.8331 2.53405 47.5513 3.47816 47.5513 4.64458C47.5513 5.81101 46.8331 6.75512 45.948 6.75512ZM47.5513 20.029C47.5513 18.864 46.8331 17.9185 45.948 17.9185H21.4802C20.5952 17.9185 19.8769 18.864 19.8769 20.029C19.8769 21.194 20.5952 22.1395 21.4802 22.1395H45.948C46.8331 22.1395 47.5513 21.194 47.5513 20.029ZM38.0736 12.3382C38.0736 11.1718 37.3553 10.2277 36.4702 10.2277H1.60332C0.718289 10.2277 0 11.1718 0 12.3382C0 13.5046 0.718289 14.4487 1.60332 14.4487H36.4692C37.3553 14.4487 38.0736 13.5032 38.0736 12.3382ZM81.1003 24.9986C81.4659 24.9902 84.7014 24.91 85.8398 24.6989C93.4331 23.3102 102.48 20.0585 102.48 12.455C102.478 4.9668 93.4192 1.70813 85.8248 0.294068C84.7335 0.088642 81.53 0.00844214 81.1399 0H51.5426C50.6575 0 49.9392 0.944113 49.9392 2.11054V22.8684C49.9392 24.0334 50.6564 24.9789 51.5415 24.9789L81.0693 25C81.08 24.9986 81.0896 24.9986 81.1003 24.9986ZM53.1459 4.21967H81.11C82.4001 4.24921 84.695 4.34489 85.3705 4.47293C93.6832 6.02066 99.2703 9.22867 99.2724 12.455C99.2724 15.7587 93.696 18.999 85.3951 20.5186C84.68 20.6509 82.4151 20.7452 81.0554 20.7775L53.1459 20.7578V4.21967Z",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_5 = { class: "inline-flex justify-center items-center ml-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-sm tracking-wide truncate" }, "Dashboard", -1)
const _hoisted_7 = { class: "inline-flex justify-center items-center ml-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-sm tracking-wide truncate" }, "Shop", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-14 px-5 py-3 hidden md:block text-center text-xs" }, "Copyright Solarus.club 2022", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('/dashboard'))),
            href: "",
            class: _normalizeClass(["relative flex flex-row items-center h-11 focus:outline-none hover:bg-Hover text-white-600 hover:text-white-800 border-l-4 border-transparent hover:border-Secondary pr-6 cursor-pointer", {
              'border-Secondary': _ctx.$route.path === '/dashboard',
              'bg-Hover': _ctx.$route.path === '/dashboard',
            }])
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_ion_icon, { icon: _ctx.homeOutline }, null, 8, ["icon"])
            ]),
            _hoisted_6
          ], 2)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('/dashboard/purchase'))),
            href: "",
            class: _normalizeClass(["relative flex flex-row items-center h-11 focus:outline-none hover:bg-Hover text-white-600 hover:text-white-800 border-l-4 border-transparent hover:border-Secondary pr-6 cursor-pointer", {
              'border-Secondary': _ctx.$route.path === '/dashboard/purchase',
              'bg-Hover': _ctx.$route.path === '/dashboard/purchase',
            }])
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_ion_icon, { icon: _ctx.cartOutline }, null, 8, ["icon"])
            ]),
            _hoisted_8
          ], 2)
        ])
      ]),
      _hoisted_9
    ])
  ]))
}